import { type FC, type ReactNode } from 'react';
import { useNavContext } from '../../NavContext';
import styles from './styles/NavTopHeader.scss';
import classNames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    adjustToSideNav?: boolean; // reacts to sidenav collapse/expand status
    children: ReactNode;
};

export const NavTopHeader: FC<Props> = ({ adjustToSideNav = true, children }) => {
    const { status } = useNavContext();

    let paddingLeft = dibsCss.plMedium;
    if (adjustToSideNav) {
        paddingLeft =
            status === 'expanded' ? styles.sideBarNavPadding : styles.sideBarNavPaddingCollapsed;
    }

    return (
        <div
            className={classNames(
                dibsCss.flex,
                dibsCss.wFull,
                dibsCss.itemsCenter,
                dibsCss.h60px,
                dibsCss.borderB,
                dibsCss.borderBSolid,
                dibsCss.borderBDolphin,
                dibsCss.bgWhite,
                dibsCss.prLarge,
                paddingLeft
            )}
        >
            {children}
        </div>
    );
};
